export const objectPropsUpdate = <T>(obj: T, props: Partial<T>) => ({ ...obj, ...props });
export const objectStatePropsUpdate = <T>(props: Partial<T>) => (obj: T) => ({ ...obj, ...props });


// WEBPACK FOOTER //
// ./src/util/objectUtils.ts